<template>
  <div class="login notelogin">
    <!-- <div class="login-box">
      <router-link to="/"><img src="/static/images/login-logo.png" class="logo"></router-link>
    </div> -->
    <img style="width:100%;margin-bottom: 16px;" src="/static/images/login-bg3.png" />
    <van-cell-group>
      <div class="van-cell van-hairline van-field van-field--has-icon input-box">
        <!--<div class="van-cell__title"><i class="van-icon iconfont icon-shoujihao"></i><span>手机号</span></div>-->
        <i class="van-icon iconfont icon-shoujihao inputlabel"></i>
        <div class="van-cell__value">
          <input type="number" placeholder="请输入手机号" v-model="mobile" class="van-field__control">
        </div>
      </div>
      <div class="codebox van-cell van-hairline van-field input-box">
        <!--<div class="van-cell__title"><i class="van-icon iconfont icon-yanzhengma"></i><span>验证码</span></div>-->
        <i class="van-icon iconfont icon-yanzhengma inputlabel" style="margin-top: 8px"></i>
        <div class="van-cell__value"><input type="text" placeholder="请输入验证码" v-model="code" class="van-field__control"></div>
        <div class="van-field__button">
          <van-button slot="button" size="small" @click="getCode()" class="theme-bg send-btn" :loading="codeLoading">获取验证码</van-button>
        </div>
      </div>
      <div class="codebox van-cell van-hairline van-field input-box">
        <!--<div class="van-cell__title"><i class="van-icon iconfont icon-yanzhengma"></i><span>验证码</span></div>-->
        <!-- <i class="van-icon iconfont icon-gonghao inputlabel" style="margin-top: 8px"></i> -->
        <img src="/static//images/yanzhengma.png" class="yanzhenma">
        <div class="van-cell__value"><input type="text" placeholder="请输入图形验证码" v-model="craphicCode" class="van-field__control"></div>
        <div class="van-field__button">
          <img :src="imgUrl" alt="" @click="getGraphCode()">
        </div>
      </div>
      <van-cell class="restBox">
        <!--<router-link to="/backpass">常见问题</router-link>-->
        <!-- <router-link to="/register" class="theme-col float-right">立即注册</router-link> -->
      </van-cell>
      <van-cell style="padding: 10px 0;">
        <van-button size="large" class="theme-bg loginbtn" @click="senData()" :loading="loading">登录</van-button>
        <!-- <van-button size="large" class="theme-bg loginbtn" @click="senData()" :loading="loading">登录</van-button> -->
        <router-link to="/login" tag="div" class="theme-col text-cent">账号密码登录</router-link>
      </van-cell>
    </van-cell-group>
    <div class="prompt-wrap">
      <div>博思软件党群e家问题咨询请联系文化与品牌建设部——iboss。</div>
      <!-- <div>问题咨询请加QQ群：693266424</div> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: "index",
    data () {
      return {
        loading:false,
        codeLoading:false,
        mobile:'',
        code:'',
        imgUrl: '',
        craphicCode: ''
      }
    },
    methods: {
      goLogin: function () {
        this.$router.push({ name: 'Login' })
      },
      getGraphCode: function() {
        this.$api.post('WebApi/Login/Register/buildverifyCodeNew', {type: 'mobile_code_login'}, res => {
          if(res.data.errCode == '0000'){
            this.imgUrl = res.data.data.url
          }
        })
      },
      getCode: function () {
        var _this = this
        var reg = /^[1][3456789][0-9]{9}$/;
        if (reg.test(this.mobile)){
          this.codeLoading = true
          this.$api.post('WebApi/Login/Register/sendPhoneCode', {type: 'mobile_code_login', mobile:this.mobile, remark: '手机验证码登录'}, res => {
            if(res.data.errCode == '0000'){
              var time = 60
              var dd = setInterval(function () {
                time--
                $(".notelogin .codebox .van-button").html(time+' s')
                if(time <= 0){
                  clearInterval(dd)
                  _this.codeLoading = false
                  $(".notelogin .codebox .van-button").html('<span class=\\"van-button__text\\">重新发送</span>')
                }
              },1000)
              this.$toast("发送成功请注意查收");
            }else {
              this.$toast(res.data.desc);
              _this.codeLoading = false
            }
          })
        }else{
          this.$toast("请输入正确的手机号码");
          return false;
        }
      },
      senData: function () {
        this.loading = true
        this.$api.post('WebApi/Login/Index/loginByCode', {mobile:this.mobile,code:this.code, captcha_code: this.craphicCode}, res => {
          if(res.data.errCode == '0000'){
            localStorage.setItem("BLHuser",res.data.data)
            this.$router.replace({ name: 'Home' })
            // location.reload()
          }else{
            this.$toast(res.data.desc);
          }
          this.loading = false
        })
      },
    },
    mounted () {
      this.getGraphCode()
    },
  }
</script>

<style lang="less" scoped>
  .login{
    width: 100%;
    min-height: 100vh;
    // background-image: url("/static/images/login-bg.png");
    background-size: 100% 100%;
    .input-box {
      border: 1px solid #DBDCDE;
      margin-bottom: 12px;
      background-color: #F5F6FA;
      border-radius: 30px;
      &:first-child {
        padding: 15px;
      }
    }
    .van-cell-group{
      padding: 0 20px;
    }
    .login-box{
      padding-top: 15vh;
      padding-bottom: 25%;
      text-align: center;
    }
    .logo{
      width: auto;
      min-width: 120px;
      max-width: 170px;
    }
    .codeimg{
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
    .codebox{
      line-height: 35px;
    }
    .codebox .van-button{
      height: 30px;
      line-height: 30px;
      border: none;
    }
    .loginbtn{
      margin-bottom: 15px;
      padding: 0 15px;
      border-radius: 30px;
      background: #101a86 !important;
    }
    .restBox::after{
      border-bottom-width:0;
    }
    .inputlabel{
      vertical-align: middle;
      font-size: 20px;
      margin-right: 15px;
      margin-top: 2px;
    }
    .van-cell__title{
      .iconfont{
        vertical-align: middle;
        font-size: 20px;
        margin-right: 5px;
      }
    }
    .send-btn {
      background: #101a86 !important;
    }
    .van-cell:not(:last-child)::after {
      content: ' ';
      position: absolute;
      pointer-events: none;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      left: 15px;
      right: 0;
      bottom: 0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
      border-bottom: none !important;
    }
    .border-bottom-909193 {
      border-bottom: 1px solid #909193;
    }
  }
  .prompt-wrap {
    width: 100%;
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    div {
      color: #b7b8bb;
      padding: 0 10px;
    }
  }
  .yanzhenma {
    width: 20px;
    height: 20px;
    margin-top: 8px;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/notelogin.vue